import {Component, OnInit, Input} from '@angular/core';
import {LeftMenuComponent} from './left-menu.component';
import {AuthentificationService} from './authentification.service';
import {Router} from '@angular/router';

@Component({
    selector: 'my-app',
    styleUrls: ['./styles/app.component.css', './styles/iconfont/material-icons.css'],
    templateUrl: './templates/app.component.html',
    providers: [LeftMenuComponent, AuthentificationService]
})

export class AppComponent {
    name = 'Angular';
    m_opened: boolean;
    ml_opened: boolean;
    show_dialog: boolean = false;
    sudo_left_menu = false;

    valTest: string = "aa";

    indice: number = -1;
    selected_app: number = -1;

    options = {
        weekday: "long", year: "numeric", month: "short",
        day: "numeric"//, hour: "2-digit", minute: "2-digit"  
    };
    date_now = new Date().toLocaleDateString("fr-FR", this.options);

    hide_infos: boolean = false;
    user_fname = "";
    user_lname = "";

    constructor(
        private left_menu: LeftMenuComponent,
        private authentification_service: AuthentificationService,
        private router: Router

    ) {
        this.CheckUSerSession();
    }


    hide_wrapper(param: boolean): void {
        this.show_dialog = param;
    }

    HideMenu(): void {
        this.m_opened = false;
    }

    ShowMenu() {
        this.m_opened = true;
    }

    ngOnInit(): void {

        this.m_opened = true;
        this.ml_opened = false;
    }

    fold(): void {
        if (this.m_opened) {
            this.m_opened = !this.m_opened;
            this.ml_opened = !this.ml_opened;
        } else {
            this.ml_opened = !this.ml_opened;
            this.m_opened = !this.m_opened;
        }

    }

    //Left Menu item
    GetParent(): void {
        console.log(this.valTest);
        var sub_item_link = this.valTest;
        console.log(this.valTest);
        for (let i = 0; i < this.left_menu.menu_items.length; i++) {
            //  console.log()

            for (let j = 0; j < this.left_menu.menu_items[i].children.length; j++) {  
                if (this.left_menu.menu_items[i].children[j].link == sub_item_link) {
                    this.indice = i;
                    this.selected_app = j;
                    //this.current_item = 2;
                    // this.test = "Niova";

                    break;
                }
            }
        }
        console.log(this.indice);
        console.log(this.selected_app);
    }

    myValueChange(event) {
        this.valTest = event;
        this.indice = -1;
        this.selected_app = -1;
    }

    IsUserLogOut(): void {
        console.log("LogOut");
        this.authentification_service.LogOut().then(result => {
            console.log(result);
            this.CheckUSerSession();
        });
        //        //console.log(action);
        //        if (action === "authentification") {
        //            //LOGout
        //            this.authentification_service.LogOut().then(result => {console.log(result)});
    }

    CheckUSerSession(): void {
        this.authentification_service.UserCheckSession().then(result => {
            if (result['id_user'] === 0) {
                this.router.navigate(['authentification'])
            }
            else {
                this.user_fname = result['user_firstname'];
                this.user_lname = result['user_lastname'];
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts